import styled from 'styled-components';
import { Button } from 'antd';

export const CustomButton = styled(Button)`
	height: 40px;
	font-size: 16px;
	line-height: 24px;
	border-radius: 4px;
	background-color: ${({ theme, type }) => (type === 'primary' ? theme.colors.primary : null)};
`;
